// Models
import { Dictionary } from 'lodash';
import { ShortAgentResponse } from 'app/modules/agents/responses';

export enum DropdownActionTypes {
  RETRIEVE_DROPDOWN_AGENTS = '@@dropdown/RETRIEVE_DROPDOWN_AGENTS',
  RETRIEVE_DROPDOWN_AGENTS_SUCCESS = '@@dropdown/RETRIEVE_DROPDOWN_AGENTS_SUCCESS',
}

export interface DropdownState {
  agents: Dictionary<ShortAgentResponse>;
}
